var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _path, _g, _g2, _path2, _g3, _path3, _g4, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHungaryHatoslotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 27.923,
    cy: 29.882,
    r: 6.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d79097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101,
    stopColor: "#d58a94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#d1788b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c95b7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#bf3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#b2004c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70041"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 26.369,
    cy: 30.558,
    r: 3.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#fdf9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#f7e7ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7e6ec"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 27.51,
    cy: 28.54,
    r: 2.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#fff",
    stopOpacity: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 15.828,
    cy: 19.611,
    r: 6.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#fee17d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fedf70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#fddb5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#fdd53d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdd53c"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 15.693,
    cy: 22.111,
    r: 5.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#fffef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#fffae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7d6"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 15.983,
    cy: 20.058,
    r: 2.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#fff",
    stopOpacity: 0.927
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.833 36.251a11.07 11.07 0 0 1 8.303 3.737v-3.346c0-1.258 1.211-2.107 2.383-2.107h2.536a2.4 2.4 0 0 1 1.03.248 2.467 2.467 0 0 1 1.03-.248h2.707a1.935 1.935 0 0 1 1.277.458c1.868-1.01 4.223-1.001 6.111-.038a1.98 1.98 0 0 1 1.23-.4h7.093c.62 0 1.058.143 1.373.362 2.212-1.287 4.995-1.258 7.045.286 2.011-1.821 5.262-1.773 7.617-.705 1.163.534 2.879 1.687 2.908 3.174.019 1.039-.601 1.544-1.22 2.24 1.201 1.544 1.173 3.708.105 5.329h13.727a2.2 2.2 0 0 1 2.116 1.687 8.58 8.58 0 0 1 1.459-.877v-1.392c0-1.201.982-2.183 2.174-2.183h2.069c1.192 0 2.174.991 2.174 2.183v1.106c3.842 1.439 6.092 5.51 6.092 9.523 0 5.091-3.623 10.048-8.98 10.048-3.146 0-5.787-1.716-7.388-4.366v1.964a2.187 2.187 0 0 1-2.174 2.183h-4.137a2.187 2.187 0 0 1-2.174-2.183v-8.475h-1.411v8.475a2.187 2.187 0 0 1-2.174 2.183h-4.128a2.187 2.187 0 0 1-2.174-2.183v-2.936c-2.574 5.443-8.961 7.102-13.527 3.136a2.176 2.176 0 0 1-2.145 1.878l-8.036-.105a2.187 2.187 0 0 1-2.174-2.183v-2.011c-1.764 3.012-4.738 5.024-8.198 5.443-5.596.677-10.277-2.45-11.869-7.798-6.597.095-11.649-4.662-11.649-11.03 0-6.196 4.852-11.077 11.001-11.077z",
    fill: "#e51442"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#eb7087"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.833 37.5c4.814 0 8.808 3.527 9.571 8.151 5.415-.887 10.515 2.955 11.163 8.446.639 5.338-3.155 10.181-8.456 10.82-5.138.62-9.828-2.955-10.686-8.036a9.695 9.695 0 0 1-1.592.133c-5.358 0-9.695-4.366-9.695-9.762 0-5.386 4.337-9.752 9.695-9.752z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.223 39.988c1.287.896 1.668 1.983 1.392 3.289-.391 1.859-2.145 2.86-3.956 2.841-.877-.01-1.811-.162-2.66-.591-.715-.362-1.363-.934-1.897-1.582-1.907 2.707-5.434 2.726-7.588.458-1.163-1.22-1.687-2.745-1.42-4.576h-.887v5.539a.725.725 0 0 1-.725.725h-2.774a.725.725 0 0 1-.725-.725v-5.539h-1.182l-.21 5.548c.019.458-.324.686-.782.667-.667-.095-3.384.038-3.365-.677l-.448-.01c0 .601-2.641.601-3.289.696-.219.048-.505-.229-.677-.381-.124.086-.238.153-.4.153h-2.755c-.887 0-.725-1.02-.725-1.621l-.257-.01c0 .601-.029 1.706-.915 1.706l-2.479-.019c-.4 0-.934-.181-.934-.582v-8.78c0-.4.534-.648.934-.648h2.536c.4 0 .896.324.896.725v3.889h.276v-3.889c0-.4.496-.725.896-.725h2.707c.543 0 .82.715.82 1.182 1.716-1.954 5.176-2.002 7.083-.086 0-.467.172-1.077.725-1.077h7.093c.734 0 .725.839.725 1.354 2.078-2.545 5.882-2.469 7.855.162 1.42-3.155 6.778-2.622 8.732-.172a.736.736 0 0 1 .01.953l-1.63 1.802zm-11.106-.81c-1.449 0-1.449 2.879 0 2.879 1.439 0 1.439-2.879 0-2.879zm-16.101 1.077v1.287h.458v-1.287c0-.048-.458-.048-.458 0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff139",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.519 37.185h2.526v4.671h2.059v-4.671h2.536v8.17h-2.536v-1.659h-2.059v1.659h-2.526zm15.91-.419h7.093v2.326h-2.278v6.263h-2.526v-6.263H41.43zm22.212 2.784 1.592-1.926c-1.907-2.45-7.093-2.402-7.664.686-.296 1.621 1.02 2.45 2.66 3.031.372.133 2.536.572 2.05 1.287-.515.753-2.736-.867-3.089-1.211l-1.687 1.859c1.02 1.382 2.679 2.097 4.166 2.116 3.594.038 4.414-4.013 1.487-5.157-1.277-.496-2.65-.848-2.564-1.42s1.449-.419 3.051.734zm-10.524-3.47c2.402 0 4.357 2.05 4.357 4.576s-1.954 4.576-4.357 4.576c-2.412 0-4.357-2.05-4.357-4.576-.01-2.526 1.945-4.576 4.357-4.576zm0 2.374c1.01 0 1.821.972 1.821 2.164 0 1.201-.82 2.174-1.821 2.174-1.01 0-1.821-.972-1.821-2.174-.01-1.192.81-2.164 1.821-2.164zm-19.571 6.949 2.85-.41v-1.258h1.64v1.258l2.85.41.21-5.52c.181-4.747-7.931-4.747-7.75 0l.2 5.52zm2.85-3.022v-2.383c0-1.01 1.64-1.01 1.64 0v2.383h-1.64z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.712 46.68h4.128a.725.725 0 0 1 .725.725v10.172h3.184a.734.734 0 0 1 .4.124c-1.316-4.967 1.754-11.02 7.302-11.02 3.317 0 5.844 2.259 6.969 5.148v-4.423a.725.725 0 0 1 .725-.725h18.942a.725.725 0 0 1 .725.725v3.308c.925-1.706 2.383-3.07 4.29-3.699V44.64a.725.725 0 0 1 .725-.725h2.069a.725.725 0 0 1 .725.725v2.193c3.813.839 6.092 4.671 6.092 8.437 0 4.29-2.984 8.599-7.531 8.599s-7.531-4.309-7.531-8.599a9.676 9.676 0 0 1 .276-2.278h-1.582v9.933a.725.725 0 0 1-.725.725h-4.14a.725.725 0 0 1-.725-.725v-9.924h-4.309v9.933a.725.725 0 0 1-.725.725h-4.128a.725.725 0 0 1-.725-.725v-9.933c-.429 0-1.802.086-2.116-.105 1.287 4.957-1.783 10.982-7.312 10.982-3.327 0-5.853-2.269-6.978-5.176v4.233a.725.725 0 0 1-.725.725h-8.036a.725.725 0 0 1-.725-.725v-15.53a.74.74 0 0 1 .734-.725zm49.466 6.092c-2.145 0-2.145 5.005 0 5.005 2.154.01 2.154-5.005 0-5.005zm-33.728 0c-2.183 0-2.183 5.005 0 5.005 2.193.01 2.193-5.005 0-5.005z",
    fill: "#eb7087"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.712 47.405h4.128v10.896h3.909v4.623h-8.036v-15.52zm23.432 0h9.047v4.871h-2.46v10.658h-4.128V52.276h-2.46zm9.876 0h9.056v4.871h-2.46v10.658h-4.128V52.276H71.02zm-17.569 0c-3.804 0-6.892 3.527-6.892 7.874s3.089 7.865 6.892 7.865c3.813 0 6.892-3.518 6.892-7.865s-3.079-7.874-6.892-7.874zm0 4.643c-1.325 0-2.393 1.449-2.393 3.232s1.077 3.232 2.393 3.232c1.325 0 2.402-1.449 2.402-3.232 0-1.792-1.077-3.232-2.402-3.232zm32.364-4.48c-3.108.725-5.443 3.899-5.443 7.712 0 4.347 3.051 7.865 6.807 7.865s6.807-3.518 6.807-7.865c0-4.071-2.669-7.417-6.092-7.827V44.65h-2.069v2.917zm1.363 4.48c-1.306 0-2.364 1.449-2.364 3.232s1.058 3.232 2.364 3.232 2.364-1.449 2.364-3.232c0-1.792-1.058-3.232-2.364-3.232z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.401 48.282c3.842 3.041 4.509 8.637 1.487 12.507-3.022 3.861-8.589 4.538-12.431 1.497s-4.509-8.637-1.487-12.507 8.589-4.538 12.431-1.497z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.894 52.19a6.044 6.044 0 0 1 1.001 8.446 5.95 5.95 0 0 1-8.389 1.01 6.044 6.044 0 0 1-1.001-8.446 5.95 5.95 0 0 1 8.389-1.01z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.057 50.188c1.058.839 1.239 2.383.41 3.451s-2.364 1.249-3.432.41a2.474 2.474 0 0 1-.41-3.451 2.435 2.435 0 0 1 3.432-.41z",
    fill: "url(#c)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m27.445 54.774 3.089 1.544-.734 1.115-1.897-1.01-.515.867c2.078.419 2.307 2.221 1.516 3.308-1.363 1.868-4.671.362-4.261-2.088l1.277.629c.095 1.144 1.459 1.42 1.878.477.4-.896-.439-1.716-1.459-1.23l-.896-.667 2.002-2.946zm-2.974-1.602 1.287.677-1.868 3.556.639.305-.572 1.02-.582-.296-.391.906-1.306-.61.524-.972-2.574-1.268.582-1.068 4.261-2.25zm-1.706 3.518.887-1.868-2.126 1.268 1.239.601z",
    fill: "#1f1f1f"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.205 38.225c4.89 0 8.847 3.985 8.847 8.904s-3.966 8.904-8.847 8.904c-4.89 0-8.856-3.985-8.856-8.904s3.966-8.904 8.856-8.904z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.234 42.629c3.298 0 5.977 2.688 5.977 6.015s-2.679 6.015-5.977 6.015-5.977-2.688-5.977-6.015 2.679-6.015 5.977-6.015z",
    fill: "url(#e)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.5 47.5.334-2.679-1.897 1.01-.105 4.08c-.01.553.162 1.077.496 1.525.934 1.287 2.593 1.582 3.947.677 2.879-1.926.439-6.387-2.774-4.614zm.334 2.974c-.782-1.173 1.039-2.345 1.849-1.201.763 1.182-1.049 2.364-1.849 1.201z",
    fill: "#1f1f1f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.559 41.571a2.443 2.443 0 0 1 2.44 2.46c0 1.354-1.096 2.45-2.44 2.45s-2.44-1.096-2.44-2.45 1.096-2.46 2.44-2.46z",
    fill: "url(#f)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHungaryHatoslotto);
export default __webpack_public_path__ + "static/media/hungary_hatoslotto.688c9404bb40bb1d3d0421601ce7bdec.svg";
export { ForwardRef as ReactComponent };